import { Skeleton } from '@mui/lab';
import { connect } from 'react-redux';
import { Table } from 'react-bootstrap';
import React, { useEffect } from 'react';

import { formatTransactiontDate } from '../../../helpers/date/date';
import { fetchIncomeWalletHistoryStart } from '../../../store/actions/WalletAction';

import NothingHere from '../../../images_new/icon/nothing_here.svg?react';

import "./styles/IncomeStatement.css";
import { statementStatuses } from '../../../helpers/constants/statementStatuses';

 

export const successStatuses = ['Paid', 'Ready for Pickup', 'Refunded', 'Completed'];
export const errorStatuses = ['Un paid', 'Disputed', 'Cancelled', 'Failed', 'Error', 'Reverted', 'Expired'];

export const getStatusColor = (status) => {
  if (successStatuses.includes(status)) {
    return 'success';
  }
  if (errorStatuses.includes(status)) {
    return 'error';
  }
  return 'info';
};

const IncomeStatement = (props) => {
  const { walletHistory } = props;

  useEffect(() => {
    props.dispatch(fetchIncomeWalletHistoryStart());
  }, []);

  return (
    <div className='security statement'>
      <div className='trans-table-sec'>
        <div className='trans-table'>
          {walletHistory?.data?.history?.length ? (
            <Table bordered={false} borderless={true} responsive='true'>
              <thead className='wallet-table-head'>
                <tr>
                  <th>DATE & TIME</th>
                  <th>DESCRIPTION</th>
                  <th>AMOUNT</th>
                  <th>FEE</th>
                  <th>NET</th>
                  <th>STATUS</th>
                </tr>
              </thead>
              <tbody>
                {walletHistory.data.history.map((wallet) => (
                  <tr key={wallet.payment_id} className={wallet.status === 6 ? 'tr-failed' : ''}>
                    <td>{formatTransactiontDate(wallet.paid_date)}</td>
                    <td>
                      <span className='dark-text' dangerouslySetInnerHTML={{ __html: wallet.message }}></span>
                    </td>
                    <td>{wallet.requested_amount_formatted}</td>
                    <td>{wallet.admin_amount_formatted}</td>
                    <td>{wallet.user_amount_formatted}</td>
                    <td
                      className={`hidden-xs status-text status-text-${getStatusColor(
                        statementStatuses[wallet.status],
                      )}`}
                    >
                      {statementStatuses[wallet.status]}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <>
              <Table bordered={false} borderless={true} responsive='true'>
                <thead>
                  <tr>
                    <th>DATE & TIME</th>
                    <th>DESCRIPTION</th>
                    <th>AMOUNT</th>
                    <th>FEE</th>
                    <th>NET</th>
                    <th>STATUS</th>
                  </tr>
                </thead>
                <tbody>
                  {[...Array(8).keys()].map((item) => (
                    <tr key={item}>
                      {walletHistory.loading
                        ? [...Array(6).keys()].map((item) => (
                          <td key={item}>
                            <Skeleton animation='wave' variant='text' />
                          </td>
                        ))
                        : ''}
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className='mt-3 nothing_here d-flex justify-content-center align-items-center'>
                {walletHistory.loading ? '' : <NothingHere />}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToPros = (state) => ({
  userData: state.users,
  walletHistory: state.wallet.walletHistory,
});

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(IncomeStatement);
